module.exports = __webpack_public_path__ + "img/Glazing_stock.74b8f4da.svg";